import React from "react";

export default function Terms() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-xs font-semibold tracking-[0.2em] uppercase text-[#0052FF]">Terms &amp; Conditions</div>
        <h1 className="mt-2 font-display text-4xl font-bold tracking-tight text-[#06152D]">Terms of Service</h1>
        <p className="mt-4 text-[#52525B]">Last updated: {new Date().toLocaleDateString("en-IN", { year: "numeric", month: "long", day: "numeric" })}</p>

        <div className="mt-8 space-y-6 text-[#09090b]">
          <div>
            <h2 className="font-display text-xl font-bold text-[#06152D]">1. Nature of service</h2>
            <p className="mt-2 text-[#52525B] leading-relaxed">Loan Junction Finance Services acts as a Direct Selling Agent (DSA) / Loan Consultancy. We source, verify and submit loan and insurance enquiries to partner Banks/NBFCs. We are <strong>not</strong> a lender, bank, or insurer.</p>
          </div>
          <div>
            <h2 className="font-display text-xl font-bold text-[#06152D]">2. No approval guarantee</h2>
            <p className="mt-2 text-[#52525B] leading-relaxed">All approvals — including sanction amount, interest rate, tenure, processing fee and disbursement — are at the sole discretion of the partner Bank/NBFC. Loan Junction cannot guarantee approval.</p>
          </div>
          <div>
            <h2 className="font-display text-xl font-bold text-[#06152D]">3. Zero customer fees</h2>
            <p className="mt-2 text-[#52525B] leading-relaxed">Loan Junction does not charge customers any fees for its DSA services. Any charges appearing in your sanction letter (processing fee, documentation charge, stamp duty, etc.) are the partner Bank/NBFC's own charges.</p>
          </div>
          <div>
            <h2 className="font-display text-xl font-bold text-[#06152D]">4. Accuracy of information</h2>
            <p className="mt-2 text-[#52525B] leading-relaxed">You are responsible for providing complete and accurate information and documents. Misrepresentation may result in application rejection and — if disbursed — recall by the lender.</p>
          </div>
          <div>
            <h2 className="font-display text-xl font-bold text-[#06152D]">5. Communication consent</h2>
            <p className="mt-2 text-[#52525B] leading-relaxed">By submitting your enquiry, you consent to be contacted by Loan Junction via phone, SMS, WhatsApp and email in connection with your enquiry — even if your number is registered on DND.</p>
          </div>
          <div>
            <h2 className="font-display text-xl font-bold text-[#06152D]">6. Jurisdiction</h2>
            <p className="mt-2 text-[#52525B] leading-relaxed">Any disputes shall be subject to the exclusive jurisdiction of the courts at Siddipet, Telangana.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
